import { password, email } from '@rxweb/reactive-form-validators';

export class UserLogin {
  @email()
  email: string;

  @password({
    validation: {
      maxLength: 10,
      minLength: 5,
      digit: true,
      specialCharacter: true,
    },
  })
  password: string;
}
